const LANDING_CN = Object.freeze({
  'landing.title': '登入\n你的桥彼道\n帐户',
  'landing.subtitle': '欢迎回来！请登入你的帐户',

  'landing.referral.title.lian_lian_pay': '连连客户',
  'landing.referral.subtitle.lian_lian_pay': '欢迎你使用桥易贷服务',

  'landing.referral.title.winit_corporation': '万邑通客户',
  'landing.referral.subtitle.winit_corporation': '欢迎你使用桥易贷服务',
});

export { LANDING_CN };
